import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
import { BreadcrumbVariants } from '@primer/react-brand';
import { PropTableValues } from '../../../src/components';
import doOverflow from './images/do-overflow.png';
import dontOverflow from './images/dont-overflow.png';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Breadcrumbs} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Breadcrumbs>
  <Breadcrumbs.Item href="/">Resources</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/copilot">GitHub Copilot</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/copilot/chat" selected>
    Chat
  </Breadcrumbs.Item>
</Breadcrumbs>
`}</code></pre>
    <h3>{`Accent`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Breadcrumbs variant="accent">
  <Breadcrumbs.Item href="/">Resources</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/copilot">GitHub Copilot</Breadcrumbs.Item>
  <Breadcrumbs.Item href="/copilot/chat" selected>
    Chat
  </Breadcrumbs.Item>
</Breadcrumbs>
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <p>{`Ensure that the text of each individual Breadcrumb item fits entirely within a 320px wide viewport. Failure to do this violates `}<a parentName="p" {...{
        "href": "https://github.com/github/accessibility-audit-guide/blob/main/web/WCAG/1.4.10%20Reflow.md"
      }}>{`WCAG 1.4.10 Reflow`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src={doOverflow} alt="" />
    <Caption mdxType="Caption">
      Use short Breadcrumb item names to ensure they fit within a 320px wide
      viewport.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src={dontOverflow} alt="" />
    <Caption mdxType="Caption">
      Don't allow Breadcrumb item names to overflow the 320px wide viewport, as
      this violates WCAG 1.4.10 Reflow.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Component props`}</h2>
    <h3>{`Breadcrumbs `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><PropTableValues values={BreadcrumbVariants} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specify alternative breadcrumb appearance`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Breadcrumbs.Item `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`selected`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used for indicating the active link`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`href`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`URL of the page the link goes to`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      